<template lang="pug">
  base-content(title="申請書PDF作成完了" type="is-success")

    .content.has-text-centered
      p 申請書のPDFを作成しました。ご利用ありがとうございました。
      p.has-text-weight-bold.is-size-4 申請書ID:&nbsp;
        span.has-text-info(data-testid="app_id") {{app_id}}
      p(v-if="isPartnerApp()") PDFをダウンロードいただき、販売パートナー様までご送付ください。
      p(v-else) PDFをダウンロードいただき、弊社担当窓口までご送付ください。

      hr

      .buttons.is-centered
        a.button.is-medium.is-main-link(@click.prevent="pdfDownload", data-testid="pdf-download")
          span.has-text-weight-bold PDFをダウンロードする
          b-icon(icon="arrow-circle-down")
        a.button.is-medium.is-main-link(@click="exportData", data-testid="data-export")
          span.has-text-weight-bold データをダウンロードする
          b-icon(icon="arrow-circle-down")

      hr

      p 上記ダウンロード処理はページを移動すると行えなくなります。

      .buttons.is-centered
        router-link.button.is-medium.is-default(:to="{name: isPartnerApp() ? 'partner' : 'enduser'}", data-testid="link-to-top")
          span.has-text-weight-bold 申請書の選択画面に戻る
</template>

<script>
import BaseContent from '@/components/BaseContent'
import AppMessage from '@/components/AppMessage'
import ButtonBar from '@/components/apps/com/ButtonBar'
import MixinApplication from '@/mixins/application'
import ModalExport from '@/components/apps/com/DataExportModal'
import Api from '@/repositories/api'
import Util from '@/utils/util'

export default {
  name: 'Saved',
  mixins: [ MixinApplication ],
  components: { BaseContent, AppMessage, ButtonBar },
  watch: {
    downloaded (downloaded) {
      this.setPageLeave(downloaded)
    }
  },
  methods: {
    pdfDownload () {
      const ApplicationsApi = Api.get('applications')
      ApplicationsApi
        .pdfDownload(this.token, this.app_id)
        .then(({ data }) => {
          Util.getFileDL(data, this.app_id + '.pdf')
          this.setDownloaded() // PDFダウンロード済みフラグ
        })
        .catch((e) => {
          Util
            .blobToJson(e.response.data)
            .then((data) => {
              this.$notification.open({
                message: data.data.message,
                type: 'is-danger',
                'has-icon': true
              })
            })
        })
    },
    exportData () {
      this.$modal.open({
        component: ModalExport,
        props: {
          app_id: this.app_id,
          token: this.token // get用
        },
        hasModalCard: true
      })
    },
    setPageLeave (downloaded) {
      // ダウンロード済みなら移動前確認をしない
      this.$route.matched[0].meta.confirmLeave = !downloaded
    }
  },
  created () {
    this.mode = 'comp'
    this.setPageLeave(this.downloaded)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/apps/Saved.vue